import { VideoConfigVariant } from '@ca/common/types'
import { trpc } from 'api'
import React, { useEffect } from 'react'
import { Platform, View } from 'react-native'
import { VideoView, VideoPlayer } from 'expo-video'

const VimeoVideo = ({
  url,
  player,
}: VideoConfigVariant & {
  player?: VideoPlayer
}) => {
  const { data } = trpc.vimeo.getVideoFromUrl.useQuery({ url })

  const file = data?.files.find(
    (f) =>
      f.quality ===
      Platform.select({
        default: 'hls',
        web: 'hd',
      })
  )

  // Replace source on the shared player when the resolved Vimeo URL becomes available
  useEffect(() => {
    if (file?.link && player) {
      player.replace({ uri: file.link })
    }
  }, [file?.link, player])

  if (!player) return null

  return (
    <View className="h-full w-full overflow-hidden rounded-2xl bg-black/0">
      <VideoView
        player={player}
        style={{
          alignSelf: 'center',
          flex: 1,
          width: '100%',
          height: '100%',
        }}
        contentFit="contain"
      />
    </View>
  )
}

export default VimeoVideo
